import React from 'react';
import './Photographydetail.css';

const Photographydetail = () => (
  <section className="Photography-detail">
    <div className="Photography-detail__container">
      <div className="Photography-detail__content">
        <p className="Photography-detail__paragraph">
          At Moyer Production Co., we deliver professional photography services that combine big-city polish with small-town care. Based in Bonney Lake, Washington, we serve Puyallup, Tacoma, and the entire Puget Sound region, capturing high-quality visuals for businesses, events, and personal brands that want to stand out.
        </p>
        <p className="Photography-detail__paragraph">
          From product photography and executive headshots to branding portraits, team photos, and lifestyle shoots, we tailor every session to match your goals and brand identity. We guide you through the full process—creative direction, shot planning, lighting design, and on-site adjustments—to ensure each image speaks directly to your audience.
        </p>
        <p className="Photography-detail__paragraph">
          We shoot with professional full-frame cameras, tethered capture setups, and studio-quality lighting—whether at our in-home Bonney Lake studio or on-location at your office, shop, or outdoor space. With real-time previews on calibrated monitors, you're involved in every step and can approve shots or request changes on the spot.
        </p>
        <p className="Photography-detail__paragraph">
          All photos go through professional editing and retouching, with final galleries delivered in multiple formats for print, web, and social media. We also offer ongoing content packages for businesses that need seasonal updates, monthly marketing images, or consistent content creation—complete with discounted rates and guaranteed booking slots.
        </p>
        <p className="Photography-detail__paragraph">
          Every shoot is backed by our commitment to quality, clear communication, and a satisfaction guarantee. Whether you're refreshing your team page, launching a new product, or promoting your service in the local market, we'll help you look your best—on every platform, every time.
        </p>
      </div>
    </div>
  </section>
);

export default Photographydetail;
